export default __webpack_public_path__ + "static/header_bg-eb687e21a2384a87add95285b28efd3a.jpg";